import React from 'react'

const OrderCreationIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <g data-name="Layer 32">
                        <path
                            d="M53.5 36.65V18a1 1 0 0 0-.5-.87l-24.25-14a1 1 0 0 0-1 0l-24.25 14A1 1 0 0 0 3 18v28a1 1 0 0 0 .5.87l24.25 14a1 1 0 0 0 1 0l9.11-5.26a12.74 12.74 0 1 0 15.64-19zM28.25 5.15 50.5 18l-11.16 6.44-20.66-13.76zm0 25.7L6 18l10.75-6.21L37.4 25.56zM5 19.73l22.25 12.85v25.69L5 45.42zm24.25 38.54V32.58l9-5.23v7.79a1 1 0 0 0 2 0V26.2l11.2-6.47v16.21a12.44 12.44 0 0 0-3.25-.44 12.73 12.73 0 0 0-11.37 18.39zm19 .73A10.75 10.75 0 1 1 59 48.25 10.76 10.76 0 0 1 48.25 59z"
                            fill="#092c4c"
                            opacity={1}
                            data-original="#000000"
                            className=""
                        />
                        <path
                            d="m53 43.06-6.2 8.18-3.25-3.82A1 1 0 0 0 42 48.71l4 4.78a1 1 0 0 0 .76.35 1 1 0 0 0 .77-.4l6.95-9.17A1 1 0 1 0 53 43.06z"
                            fill="#092c4c"
                            opacity={1}
                            data-original="#000000"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default OrderCreationIcon